import { useCallback, useMemo, useState } from 'react';
import { debounce } from 'utilities/helperFunctions';

export const usePdfSettings = () => {
    const [{ viewPort, numPages, pageHeight, scale }, setPdfSettings] = useState({
        viewPort: undefined,
        numPages: undefined,
        pageHeight: undefined,
        scale: undefined,
    });

    const calculatePageHeight = (width, viewPort) => viewPort.viewBox[3] * (width / viewPort.viewBox[2]);
    const calculateDocumentScale = (width, viewPort) => width / viewPort.viewBox[2];

    const handleDocumentResize = useMemo(
        () =>
            debounce(({ width }) => {
                if (!viewPort) return;
                const pageHeight = calculatePageHeight(width, viewPort);
                const scale = calculateDocumentScale(width, viewPort);
                setPdfSettings(prevSettings => ({ ...prevSettings, pageHeight, scale }));
            }, 150),
        [viewPort]
    );

    const handleDocumentLoadSuccess = useCallback(
        width => async pdfObject => {
            const page = await pdfObject.getPage(1);
            const viewPort = page.getViewport();
            const pageHeight = calculatePageHeight(width, viewPort);
            const scale = calculateDocumentScale(width, viewPort);
            setPdfSettings({ viewPort, numPages: pdfObject.numPages, pageHeight, scale });
        },
        []
    );

    return { pdfSettings: { numPages, pageHeight, scale }, handleDocumentLoadSuccess, handleDocumentResize };
};
